/**
 * @generated SignedSource<<aa5ef50d83a71c2aef7cfb18bd2264e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Details_featuredDeal$data = {
  readonly artist: {
    readonly " $fragmentSpreads": FragmentRefs<"KeyPerformanceStats_artist">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"Terms_featuredDeal" | "TikTokData_featuredDeal" | "WhyInvest_featuredDeal">;
  readonly " $fragmentType": "Details_featuredDeal";
};
export type Details_featuredDeal$key = {
  readonly " $data"?: Details_featuredDeal$data;
  readonly " $fragmentSpreads": FragmentRefs<"Details_featuredDeal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Details_featuredDeal",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Terms_featuredDeal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WhyInvest_featuredDeal"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArtistNode",
      "kind": "LinkedField",
      "name": "artist",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "KeyPerformanceStats_artist"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TikTokData_featuredDeal"
    }
  ],
  "type": "FeaturedDealNode",
  "abstractKey": null
};

(node as any).hash = "13053ec210880062121d42b47efaa570";

export default node;
